<template>
  <footer class="footer bg-black small text-center text-light">
    <div class="container px-4 px-lg-5">
      <p class="text-light text-opacity-75">
        copyright &copy; ironwood flutes {{ copyrightYears }}
      </p>
      <div class="container col-12 col-lg-4 col-md-6">
        <div class="col text-center">
          <div class="col-12">
            <router-link
              to="/impressum"
              class="link-light fw-bold link-opacity-75 text-decoration-none"
              >legal notice</router-link
            >
          </div>
          <div class="col-12">
            <router-link
              to="/datenschutz"
              class="link-light fw-bold link-opacity-75 text-decoration-none"
              >privacy policy</router-link
            >
          </div>
          <div class="col-12">
            <a
              role="button"
              tabindex="0"
              class="link-light fw-bold link-opacity-75 text-decoration-none"
              style="cursor: pointer"
              data-bs-toggle="modal"
              data-bs-target="#citesModal"
              >cites</a
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- AGB & CITES remain modals for now (currently unlinked) -->
  <AgbComponent />
  <CitesComponent />
</template>
<script lang="ts">
import AgbComponent from "@/components/general/AgbComponent.vue";
import CitesComponent from "@/components/general/CitesComponent.vue";

const FOUNDING_YEAR = 2023;

export default {
  name: "FooterSectionComponent",
  components: {
    AgbComponent,
    CitesComponent,
  },
  computed: {
    copyrightYears(): string {
      const now = new Date().getFullYear();
      return now > FOUNDING_YEAR
        ? `${FOUNDING_YEAR}–${now}`
        : `${FOUNDING_YEAR}`;
    },
  },
};
</script>
